import ReactHtmlParser from 'react-html-parser';
import DOMPurify from 'dompurify';

const ParsedContent = ({ content }) => content && ReactHtmlParser(DOMPurify.sanitize(content));

export default ParsedContent;
